import { render, staticRenderFns } from "./imgToShow.vue?vue&type=template&id=d964607a&scoped=true&"
import script from "./imgToShow.vue?vue&type=script&lang=js&"
export * from "./imgToShow.vue?vue&type=script&lang=js&"
import style0 from "./imgToShow.vue?vue&type=style&index=0&id=d964607a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d964607a",
  null
  
)

export default component.exports